import { isLocalStorageAvailable } from '../../core/utils/storage';

const getStorage = () => (isLocalStorageAvailable() ? window.localStorage : null);

const setItem = (address, value) => {
    const storage = getStorage();
    if (!storage) {
        return;
    }

    storage.setItem(address, value);
};

const getItem = (address) => {
    const storage = getStorage();
    if (!storage) {
        return null;
    }

    return storage.getItem(address);
};

const removeItem = (address) => {
    const storage = getStorage();
    if (!storage) {
        return;
    }

    storage.removeItem(address);
};

const getParsedItem = (address) => {
    const item = getItem(address);
    if (!item) {
        return null;
    }

    try {
        return JSON.parse(item);
    } catch (error) {
        removeItem(address);
        return null;
    }
};

const SESSION_ID_ADDRESS = '@sessionId';
const getSessionIdKey = (waitingRoomId) => (
    waitingRoomId ? `${SESSION_ID_ADDRESS}:${waitingRoomId}` : SESSION_ID_ADDRESS
);
export const saveSessionId = (userId, waitingRoomId) => setItem(getSessionIdKey(waitingRoomId), userId);
export const getSessionId = (waitingRoomId) => getItem(getSessionIdKey(waitingRoomId));
export const removeSessionId = (waitingRoomId) => removeItem(getSessionIdKey(waitingRoomId));

const RECAPTCH_PAASSED_ADDRESS = '@recaptchaPassed';
export const saveRecaptchaPassed = (recaptchaPassed) => setItem(RECAPTCH_PAASSED_ADDRESS, recaptchaPassed);
export const getRecaptchaPassed = () => getItem(RECAPTCH_PAASSED_ADDRESS);

const EXPIRATION_TIME = 60 * 60 * 1000;

const AUTH_DATA_ADDRESS = '@authData';
export const saveAuthData = (authData) => {
    const dataWithExpiry = {
        value: authData,
        expiry: Date.now() + EXPIRATION_TIME,
    };
    setItem(AUTH_DATA_ADDRESS, JSON.stringify(dataWithExpiry));
};
export const getAuthData = () => {
    const data = getParsedItem(AUTH_DATA_ADDRESS);
    if (!data || Date.now() > data.expiry) {
        removeAuthData();
        return null;
    }

    return data.value;
};
export const removeAuthData = () => removeItem(AUTH_DATA_ADDRESS);

const USER_DATA_ADDRESS = '@userData';
export const saveUserData = (userData) => {
    const dataWithExpiry = {
        value: userData,
        expiry: Date.now() + EXPIRATION_TIME,
    };
    setItem(USER_DATA_ADDRESS, JSON.stringify(dataWithExpiry));
};
export const getUserData = () => {
    const data = getParsedItem(USER_DATA_ADDRESS);
    if (!data || Date.now() > data.expiry) {
        removeUserData();
        return null;
    }

    return data.value;
};
export const removeUserData = () => removeItem(USER_DATA_ADDRESS);

const CODE_VERIFIER_ADDRESS = '@codeVerifier';
export const setCodeVerifier = (codeVerifier) => {
    const dataWithExpiry = {
        value: codeVerifier,
        expiry: Date.now() + EXPIRATION_TIME,
    };
    setItem(CODE_VERIFIER_ADDRESS, JSON.stringify(dataWithExpiry));
};
export const getCodeVerifier = () => {
    const data = getParsedItem(CODE_VERIFIER_ADDRESS);
    if (!data || Date.now() > data.expiry) {
        removeCodeVerifier();
        return null;
    }

    return data.value;
};
export const removeCodeVerifier = () => removeItem(CODE_VERIFIER_ADDRESS);
